import { useContext } from '@nuxtjs/composition-api'

export default () => {
  const {
    app: { $cookies }
  } = useContext()

  return $cookies
}
